import api from "@axios";
import AuthHelpers from "@/utils/auth-helpers";
export default {
  namespaced: true,
  state: {
    loading: false,
    loadingSections: false,
    sections: [],
    content: {},
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
    setLoadingSections(state, val) {
      state.loadingSections = val;
    },
    setSections(state, val) {
      state.sections = val;
    },
    setContent(state, val) {
      state.content = val;
    },
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    sections(state) {
      return state.sections;
    },
    content(state) {
      return state.content;
    },
    loadingSections(state) {
      return state.loadingSections;
    },
  },
  actions: {
    async getSections({ commit }) {
      commit("setLoadingSections", true);
      try {
        const type = AuthHelpers.isUserMinistry()
          ? "min"
          : AuthHelpers.isUserTemp()
          ? "est"
          : "min";
        const data = await api
          .get("v2/help/sections", { params: { type } })
          .then((res) => res.data.data);
        commit("setSections", data);
      } catch (err) {
        console.error(err);
      } finally {
        commit("setLoadingSections", false);
      }
    },
    async getContent({ commit }, slug) {
      commit("setLoading", true);
      try {
        const data = await api
          .get(`v2/help/sections/links`, { params: { slug } })
          .then((res) => res.data.data);
        commit("setContent", data);
      } catch (err) {
        console.error(err);
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
